import { TableCell, TableHead, TableRow, TableSortLabel } from '@material-ui/core';
import React, { FC } from 'react';
import { createUseStyles } from '../../../../../../../theming';
import { Order } from '../../../../../../../interfaces/Table';

const useStyles = createUseStyles({
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
});

interface Props {
  onRequestSort: (event: React.MouseEvent<unknown>, property: string) => void;
  order: Order;
  orderBy: string;
}

interface HeadCell {
  id: string;
  label: string;
  numeric: boolean;
}

const headCells: HeadCell[] = [
  { id: 'id', numeric: false, label: 'Id' },
  { id: 'subject', numeric: true, label: 'Nom de la demande' },
  { id: 'type', numeric: true, label: 'Type' },
  { id: 'contact', numeric: true, label: 'Contact' },
  { id: 'createdAt', numeric: true, label: 'Effectuée le' },
  { id: 'updatedAt', numeric: true, label: 'Dernière mise à jour' },
  { id: 'status', numeric: true, label: 'Statut' },
];

const RequestTableHead: FC<Props> = ({ onRequestSort, order, orderBy }) => {
  const classes = useStyles();

  const createSortHandler = (property: string) => (event: React.MouseEvent<unknown>) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            style={{ fontWeight: 700 }}
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding='normal'
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default RequestTableHead;
